import SourceFlowImage from "@sourceflow-uk/sourceflowimage";

export const ImageBanner = ({
    className,
    image,
    objectFit = "cover",
}) => {

    return (
        <section className={`bg-black ${className}`}>
            <figure className="m-0">
                <SourceFlowImage
                    src={image?.url ? image?.url : "/site-assets/placeholders/img-placeholder.jpg"}
                    resize={false}
                    alt={image?.alt}
                    className="w-100 h-100"
                    style={{ objectFit: objectFit }}
                />
            </figure>
        </section>
    )
}

export default ImageBanner;
